<template>
  <div class="filterbar">
    <select>
      <option>Chats</option>
      <option>Open</option>
      <option>Queued</option>
      <option>Closed</option>
    </select>

    <input type="date" />
    <input type="date" />

    <button class="search-btn">🔍</button>
  </div>
</template>

<style scoped>
.filterbar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
}

select,
input {
  height: 42px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #fff;
  min-width: 170px;
  font-size: 14px;
}

.search-btn {
  width: 46px;
  height: 42px;
  border: none;
  border-radius: 12px;
  background: #2f80ed;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
}
</style>